export const KEYS = {
    NAME: 'name',
    MIN: 'min',
    MAX: 'max',
  },
  BREAKPOINT_DEFINITION = 'breakpoints',
  BREAKPOINT_CONFIG = {
    breakpoints: {
      xs: {
        name: 'xs',
        min: 0,
        max: 319,
      },
      sm: {
        name: 'sm',
        min: 320,
        max: 479,
      },
      md: {
        name: 'md',
        min: 480,
        max: 799,
      },
      lg: {
        name: 'lg',
        min: 800,
        max: 1279,
      },
      xl: {
        name: 'xl',
        min: 1280,
        max: 1919,
      },
      xxl: {
        name: 'xxl',
        min: 1920,
        max: 10000,
      },
    },
  };
